<template>
	<div class="stage stage--landmark">

		<div class="btn__explanation" @click="showExplanationPopup">
			<i class="fa fa-question"></i>
		</div>


		<div class="utrecht">
			<div class="inner">
				<img :src="baseUrl + questionData.visual"/>
				<!-- <object id="svgObject" :data="map" type="image/svg+xml" width="460" height="460" style="width: 100%; height: auto;">No SVG support</object> -->

				<object id="svgObject" :data="baseUrl + questionData.hit_test_svg" type="image/svg+xml" width="460" height="460" style="width: 100%; height: auto;">No SVG support</object>
			</div>
		</div>

		<div class="crosshair" style="top: calc(100% - 120px); left: 50%">
			<img :src="baseUrl + questionData.croshair_visual"/>
		</div>

		<div class="header__container">
			<div class="header" style="position: relative">
				{{question.header}}
			</div>
			<div class="subHeader" style="position: relative">
				{{question.subheader}}
			</div>
			<div class="text" style="position: relative">
				{{question.questiontext}}
			</div>
		</div>

		<ExplanationPopup 
		v-if="explanationPopupActive == true" 
		:on-click="hideExplanationPopup"/>

	</div>

</template>


<script>

	import Vue from 'vue';
	import {mapGetters , mapActions} from 'vuex';
	import Feedback from './Feedback.vue';
	import { url } from '../../../const/base';

	import { dev_env } from '../../../const/base';
	//import * as mapData from './Utrecht_plattegrond.svg';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		props:[],

		components:{
			Feedback
		},

		beforeMount(){
			
		},

		mounted(){


			let component = this;

			//this.startUtrechtScene();

			$("#svgObject")[0].addEventListener('load', function(){
				component.startUtrechtScene();
			});

		},
		data(){
			return {
				baseUrl : url,
				devEnv : dev_env,
				partOne: true,
				partOneState:0,
				partTwoState:0,
				draggedItems : 0,
				showNames:[],
				names:[],
				correctCount:[],
				currentCount:[],
				maxItem:0,
				maxCount:0,
				visuals:[],
				markerPlaced : false,
				inRedZone : false,
				explanationPopupActive: false,
			}
		},

		watch:{

			markerPlaced: function (val)
			{
				if(val){
					this.setNextButtonAction(this.nextPartForPartTwo).then(()=>{
						this.showNextButton();
					})
				}
				else{
					this.hideNextButton();
					this.partTwoState = 0;
				}
			},

			partOneState : function (val)
			{
				if(val == 0){
					this.hideNextButton();
				}
				if(val == 1){
					setTimeout(()=>{
						this.setNextButtonAction(this.partOneFinal).then(()=>{
							this.showNextButton();
						})
					},0);
				}
				if(val == 2){
					setTimeout(()=>{
						this.setNextButtonAction(this.toNextPart).then(()=>{
							this.showNextButton();
						})
					},500);

				}
			},

			partTwoState : function (val)
			{
				if(val<=1){
					let svgObject = document.querySelector("#svgObject").contentDocument;
					let root = svgObject.getElementsByClassName("cls-1")[0];
					root.style.opacity = val*.5;
					this.setNextButtonAction(this.nextPartForPartTwo).then(()=>{
						this.showNextButton();
					})
				}
			},

			partOne : function (val)
			{
				let component = this;
				if(val == false){
					setTimeout(()=>{
						$("#svgObject")[0].addEventListener('load', function(){
							//component.startUtrechtScene();
						});
					},1);
				}
			},

			
		},

		computed:{

			utrecht () {
				return require('../../../assets/utrecht/Utrecht_plattegrond.svg');
			},

			utrechtSvg () {
				return svgData;
			},

			...mapGetters([
				'currentBlock',
				'currentStage',
				'currentRound',
				'roundScore',
				'questionData',
				"roundData",
				'stageData',
			]),

			question(){return this.questionData;},


		},


		methods:{

			hideExplanationPopup(){
				this.explanationPopupActive = false;
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
			},

			partOneFinal(){
				this.partOneState = 2;
			},

			toNextPart(){
				this.partOne = false;
			},

			nextPartForPartTwo(){
				if(this.partTwoState == 1){
					this.completeRound();
				}
				else
				{
					this.partTwoState = 1;
				}

			},

			startUtrechtScene(){
				let component = this;

				console.log('start');

				// $('#svgObject').click(function(e){
					
				// 	console.log('click');

				// 	var pos = $(this).position();


			 //        let cPosX = $('.inner').offset().left;
				// 	let cPosY = $('#svgObject').offset().top;
				// 	let posX = (pos.left-cPosX)+($('.crosshair').width()/2);
				// 	let posY = (pos.top-cPosY)+($('.crosshair').height()/2);
				// 	let es = svgObject.elementFromPoint(posX, posY);
				// 	if(es != null){
				// 		//root.style.opacity = .5;
				// 		component.markerPlaced = true;
				// 		if(es.id == ""){
				// 			component.inRedZone = true;
				// 			component.setUnderWater(true);
				// 		}else{
				// 			component.inRedZone = false;
				// 			component.setUnderWater(false);
				// 		}
				// 	}else{
				// 		component.markerPlaced = false;
				// 	}

			 //        console.log((e.pageX - posX) + ' , ' + (e.pageY - posY));
				// });





				if(this.devEnv === 'local'){
					this.setNextButtonAction(this.completeRound).then(()=>{
						this.showNextButton();
					})

					return false;
				}

				if(document.querySelector("#svgObject").contentDocument == null){

					this.setNextButtonAction(this.completeRound).then(()=>{
						this.showNextButton();
					})

					return false;
				}

				let svgObject = document.querySelector("#svgObject").contentDocument;

				console.log(svgObject);

				let root = svgObject.getElementsByClassName("cls-1")[0];
				console.log(root);

				root.style.opacity = 0;



				

				$( ".crosshair" ).draggable({ containment: ".main-frame",
					start: function(){

					},
					stop: function (ev, ui) {

						let pos = $(ui.helper).offset();
						let cPosX = $('.inner').offset().left;
						let cPosY = $('#svgObject').offset().top;
						let posX = (pos.left-cPosX)+($('.crosshair').width()/2);
						let posY = (pos.top-cPosY)+($('.crosshair').height()/2);
						let es = svgObject.elementFromPoint(posX, posY);
						if(es != null){
							//root.style.opacity = .5;
							component.markerPlaced = true;
							if(es.id == ""){
								component.inRedZone = true;
								component.setUnderWater(true);
							}else{
								component.inRedZone = false;
								component.setUnderWater(false);
							}
						}else{
							component.markerPlaced = false;
						}
					}
				});
			},

			...mapActions([
				"showNextButton",
				"hideNextButton",
				"setRoundScore",
				"completeRound",
				"setNextButtonAction",
				"setUnderWater",
			]),
			
		},
	}
</script>

<style>
	.cls-2{
		opacity: 0 !important;
	}
</style>

<style scoped>

	.score-label{
		font-size: 18px;
	}

	.name-label{
		font-size: 14px;
	}

	.btn-utrecht{
		position: absolute;
		width: 40%;
		left: 30%;
		top: calc(100% - 80px);
		z-index: 3;
		box-shadow: none;
		font-weight: bold;
		padding: 5px;
		font-size: 24px;
	}

	.btn-world{
		position: absolute;
		width: 40%;
		left: 30%;
		top: calc(100% - 80px);
		z-index: 3;
	}

	.utrecht{
		width: 100%;
		height: 100%;
		position: absolute;
		display: table;
	}

	.utrecht .inner{
		width: 100%;
		display: table-cell;
		vertical-align: bottom;
	}

	.utrecht img{
		width: 100%;
		border: 0px;
		position: absolute;
		bottom: 0px;
		left: 0px;
	}

	#svgObject{
		position: absolute;
		width: 100%;
		height: auto;
		bottom: 0px;
		left: 0px;
		z-index: 1;
	}

	#valid_dropzone{
		height: 100%;
	}

	.crosshair{
		z-index: 2;
		position: absolute;
		width: 50px;
		height: 50px;
	}

	.crosshair img {
		width:100%;
	}

	.item-dragged{
		position: absolute;
		transform-origin: 50% 50%;
	}

	.visual{
		top:15%;
	}

	.visual-holder{
		margin: auto;
		height: auto;
		width: auto;
	}

	@media screen and (max-width: 360px) {
		.visual-holder{
			width: 80%;
		}
	}

	.visual-base{
		position: relative;
		width: 60%;
		margin:auto;
	}

	.visual-base img {
		width: 100%;
	}

	.scores{
		width: 100%;
	}

	.scores__item{
		width: 25%;
		display: inline-block;
		position: relative;
	}

	.scores__label{
		width: 25%;
		display: inline-block;
		position: relative;
	}

	.inventory{
		position: absolute;
		top: 70%;
	}

	.inventory .draggable {
		width: 24%;
		height: 60px;
		display: inline-block;
		position: relative;
	}

	@media screen and (max-width: 360px) {

		.inventory{
			top: 60%;
		}
		
		.inventory .draggable {
			width: 24%;
			height: 40px;
		}
	}

	.draggable.disabled{
		opacity: 0.3;
		pointer-events: none;
	}

	.inventory .icon {
		width: 100%;
		height: 100%;
		text-align: center;
	}

	.icon img{
		height: 100%;
	}

	.icon {
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
	}


</style>


// WEBPACK FOOTER //
// src/components/minigames/landmark/Index.vue